import { Button, Container, Stack, Typography } from "@mui/material";
import { UUID } from "crypto";

import { usePutApplicationsMutation } from "@services/api/applications";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

export interface LoanAppChangeInterestProps {
    applicationId: UUID;
    name: string;
    onUpdateRow?: (applicationId: UUID, attr: {}) => void;
}

export const LoanAppChangeInterest = (props: LoanAppChangeInterestProps) => {
    const [triggerPatch] = usePutApplicationsMutation();

    const userSession = useSelector((state: RootState) => state.session.user);

    const handleOnClickConfirm = async () => {
        try {
            await triggerPatch({
                applicationId: props.applicationId,
                body: {
                    interested: true,
                    user_id_modified: userSession.id,
                    user_name:
                        userSession.name
                            ?.concat(" ", userSession?.last_name ?? "", " ", userSession?.last_name_2 ?? "")
                            .trim() ?? "",
                },
            }).unwrap();

            props.onUpdateRow?.(props.applicationId, { perdioInteres: 2 });
        } catch (error) {}
    };

    return (
        <Container maxWidth="xs" sx={{ mb: 3 }}>
            <Stack
                spacing={3}
                sx={{
                    textAlign: "center",
                    alignItems: "center"
                }}>
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 500,
                        color: "#002652"
                    }}>
                    ¿Confirmas que el cliente {props.name} recupero interés?
                </Typography>

                <Button variant="contained" onClick={handleOnClickConfirm}>
                    Confirmar
                </Button>
            </Stack>
        </Container>
    );
};
